<template>
  <div>
    <BlocoFormularioCadastro voltar="/especialidade" @salvar="salvar()">
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <h4>Informações gerais</h4>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <CampoNome
                      :label-sup="'(1)'"
                      :validacao="v$.especialidade.nome"
                      :valor="especialidade.nome"
                      @atualizar="especialidade.nome = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.especialidade.nome.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                        <span
                          v-if="!v$.especialidade.nome.minLength"
                          class="help-block"
                        >
                          Campo deve ter pelo menos
                          {{ v$.especialidade.nome.$params.minLength.min }}
                          letras.
                        </span>
                        <span
                          v-if="!v$.especialidade.nome.maxLength"
                          class="help-block"
                        >
                          Campo deve ter no máximo
                          {{ v$.especialidade.nome.$params.maxLength.max }}
                          letras.
                        </span>
                      </template>
                    </CampoNome>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                    <CampoGenerico
                      id="maximoAgendamentos"
                      label="Máximo de Agendamentos"
                      placeholder="Quantidade máxima para Agendamentos"
                      mascara="99"
                      :valor="especialidade.maximoAgendamentos"
                      @atualizar="especialidade.maximoAgendamentos = $event"
                    >
                    </CampoGenerico>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <SelecionarSituacao
                      :label-sup="'(1)'"
                      :validacao="v$.especialidade.ativo"
                      :valor="especialidade.ativo"
                      :mostrar-todos="false"
                      @atualizar="especialidade.ativo = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.especialidade.ativo.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                      </template>
                    </SelecionarSituacao>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <CampoGenerico
                      id="numeracaoGuia"
                      label="Numeração Guia"
                      placeholder="Numeração Guia"
                      mascara="99"
                      :valor="especialidade.codigoNumeracaoGuia"
                      @atualizar="especialidade.codigoNumeracaoGuia = $event"
                    >
                    </CampoGenerico>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <h4>Convênios e valores</h4>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <SelecionarConvenio
                        :multiplo="true"
                        :mostrar-todos="false"
                        @atualizar="convenios = $event"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div class="forn-group">
                      <label for="tipoValor">Tipo Valor</label>
                      <select
                        id="tipoValor"
                        v-model.number="tipoValor"
                        name="tipoValor"
                        class="form-control"
                      >
                        <option disabled value=""> Selecione </option>
                        <option value="1">Fixo</option>
                        <option value="2">% da Guia</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <CampoGenerico
                      id="valor"
                      label="Valor"
                      placeholder="Valor para cálculo"
                      mascara="money"
                      @atualizar="valor = $event"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Longpress
                      v-if="conveniosSelecionados.length"
                      :on-confirm="limparConveniosSelecionados"
                      class="btn btn-danger"
                      duration="2"
                      pressing-text="Removendo selecionados {$rcounter}"
                      action-text="Removido"
                    >
                      <span class="fa fa-trash" /> Remover
                      {{ conveniosSelecionados.length }} selecionados
                    </Longpress>
                    <Longpress
                      v-else
                      :on-confirm="limparConvenios"
                      class="btn btn-danger"
                      duration="3"
                      pressing-text="Removendo {$rcounter}"
                      action-text="Removido"
                    >
                      <span class="fa fa-trash" /> Remover todos
                    </Longpress>
                    <button
                      id="botaoAdicioar"
                      type="button"
                      class="btn btn-success"
                      @click="adicionarDadosConvenios()"
                    >
                      <span class="fa fa-plus" /> Adicionar
                    </button>
                  </div>
                </div>
                <br />
                <div v-if="!especialidade.convenios.length" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="well">
                      <p>Nenhum convênio.</p>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div style="height: 415px; overflow: auto">
                    <div
                      v-for="convenio in especialidade.convenios"
                      :key="convenio._id"
                      class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                    >
                      <div class="panel panel-default">
                        <div class="panel-heading">
                          <label>
                            <input
                              style="margin-right: 8px"
                              type="checkbox"
                              @click="convenioToggle($event, convenio)"
                            />
                            {{ limitar(convenio.nome, 24) }}
                          </label>
                          <div class="pull-right">
                            <Longpress
                              :value="convenio"
                              :on-confirm="removerConvenio"
                              class="btn btn-default btn-xs"
                              duration="1"
                              pressing-text="Removendo {$rcounter}"
                              action-text="Removido"
                            >
                              Remover
                            </Longpress>
                          </div>
                        </div>
                        <table class="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td><strong>Valor</strong></td>
                              <td class="text-right">
                                <span v-if="convenio.tipoValor === 1">R$ </span>
                                {{ formatarNumero(convenio.valor) }}
                                <span v-if="convenio.tipoValor === 2"> %</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BlocoFormularioCadastro>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, minLength, required } from '@vuelidate/validators'
import numeral from 'numeral'
import Longpress from 'vue-longpress'

import { useMenu } from '@/composables/useMenu'
import { cadastroMixin } from '@/mixins/CadastroMixin'
import router from '@/router'
import ConvenioServico from '@/servicos/ConvenioServico'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'
import MensagemServico from '@/servicos/MensagemServico'
import * as formatadores from '@/utils/formatadores'

const convenioServico = new ConvenioServico()
const mensagemServico = new MensagemServico()
const especialidadeServico = new EspecialidadeServico()

export default {
  components: { Longpress },
  mixins: [cadastroMixin],
  setup() {
    useMenu(38)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      servico: new EspecialidadeServico(),
      entidade: 'especialidade',
      consulta: 'Especialidade',
      convenios: '',
      conveniosSelecionados: [],
      valor: '',
      tipoValor: '',
      especialidade: {
        nome: '',
        ativo: 'true',
        convenios: [],
        maximoAgendamentos: 0,
        codigoNumeracaoGuia: 0,
      },
    }
  },
  validations: {
    especialidade: {
      nome: { required, minLength: minLength(3), maxLength: maxLength(20) },
      ativo: { required },
      maximoAgendamentos: { required },
      codigoNumeracaoGuia: { required },
    },
  },
  methods: {
    ...formatadores,
    salvar() {
      this.v$.$touch()

      if (this.v$.especialidade.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        if (this.especialidade._id) {
          especialidadeServico
            .atualizar(this.especialidade._id, this.especialidade)
            .then((result) => {
              if (result.erro) {
                mensagemServico.alerta(result.erro.content, result.erro.title)
                return
              }

              router.replace({ name: 'Especialidade' })
            })
        } else {
          especialidadeServico.criar(this.especialidade).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Especialidade' })
          })
        }
      }
    },
    convenioToggle(e, convenio) {
      const valor = e.target.checked

      if (valor) {
        this.conveniosSelecionados.push(convenio)
      } else {
        const index = this.conveniosSelecionados.indexOf(convenio)
        this.conveniosSelecionados.splice(index, 1)
      }
    },
    processarEntidade(res) {
      this.especialidade.ativo = this.especialidade.ativo ? 'true' : 'false'
    },
    removerConvenio(convenio) {
      const index = this.especialidade.convenios.indexOf(convenio)
      this.especialidade.convenios.splice(index, 1)
    },
    limparConvenios() {
      this.especialidade.convenios = []
    },
    limparConveniosSelecionados() {
      for (const conv of this.conveniosSelecionados) {
        this.removerConvenio(conv)
      }

      this.conveniosSelecionados = []
    },
    adicionarDadosConvenios() {
      if (this.convenios !== '') {
        const conveniosArray = this.convenios.split(',')

        if (
          conveniosArray !== '' &&
          conveniosArray.length &&
          this.valor !== '' &&
          this.tipoValor !== ''
        ) {
          conveniosArray.forEach((c) => {
            const conveniosRepetidos = this.especialidade.convenios.find(
              (conv) => conv._id === c
            )

            if (typeof conveniosRepetidos === 'undefined') {
              convenioServico.recuperar(c).then((res) => {
                this.especialidade.convenios.unshift({
                  _id: res.convenio._id,
                  nome: res.convenio.nome,
                  valor: numeral(this.valor).value(),
                  tipoValor: numeral(this.tipoValor).value(),
                })
              })
            } else {
              mensagemServico.alerta('Convênio já possui valor cadastrado!')
            }
          })
        } else {
          mensagemServico.alerta(
            'Informe o valor e o tipo de valor para adicionar!'
          )
        }
      } else {
        mensagemServico.alerta('Informe o(s) convênio(s) para adicionar!')
      }
    },
  },
}
</script>
